import React, { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash} from '@fortawesome/free-solid-svg-icons';
import EditAssessmentQuestion from './EditAssessmentQuestion';


function EditQuestions(arg) {
  const [show, setShow] = useState(arg.flag);
  const [openEdit, setOpenEdit] = useState(false);
  //Map of objective answer
  const objectiveAnswerkey = {
    0 : 'a',
    1 : 'b',
    2 : 'c',
    3 : 'd',
    4 : 'e'
  }
  
  const handleClose = () => {
    setShow(false);
    arg.handler();
  }

  const deleteTQuesion=(id)=>{
     setShow(false);
    arg.deleteCB(id);
  }

  const editIndividualQuesion=(elem)=>{
    setShow(false);
    arg.handler();
    //Create a question object to pass to Edit form
    let dataObject = {
      assessmentId : arg.fullData.id,
      type : arg.fullData.assessmentType,
      question : elem.question,
      id : elem.id
  }
  if(arg.fullData.assessmentType === 1){
    dataObject.objImageSource = elem.image;
    dataObject.options = {
        options1 : elem.option1,
        options2 : elem.option2,
        options3 : elem.option3,
        options4 : elem.option4,
        options5 : elem.option5,
        answer   : elem.answer
    }
  }
  if(arg.fullData.assessmentType === 2){
    dataObject.interactiveImage = elem.image;
    dataObject.interactiveAnswer = elem.answer;
  }
    arg.editIndiviual(dataObject);
  }

  const handleShow = () => setShow(true);
  
  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false} size='lg'>
        <Modal.Header>
          <Modal.Title>Edit Questions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <ul className='qstn-list'>
              {
                arg.data && arg.data.map((element,index) => {
                  return(
                    <li key={index}>
                      <div className='qtn-box'>
                        <div>
                          <span>ID : {" "+element.id}</span>
                          <button type='button' className='btn btn-warning ml-2 push-left' onClick={()=>editIndividualQuesion(element)}><FontAwesomeIcon icon={faEdit} className='table-icon-inline'/>Edit</button>
                          <button type='button' className='btn btn-danger' onClick={()=>deleteTQuesion(element.id)}><FontAwesomeIcon icon={faTrash} className='table-icon-inline'/>Delete</button>
                        </div>
                        <div>Question : {" "+element.question}</div>
                      
                      </div>
                    </li>
                  )
                })
              }
            </ul>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button>
         
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditQuestions;

